import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { IEventMonth, ICalendarState } from '@adage/ace-calendar';
import GridCell from '../components/grid-cell';
import ListCell from '../components/list-cell';
import ListEmptyCell from '../views/list-empty-cell';
import { IArenaEvent } from '../classes/event';
import { ICalendar, IDay } from '@adage/calendar/services/calendar';

export interface ListViewRowExternalProps {
    allEvents: IDay<IArenaEvent>[];
}

type ListViewRowProps = ListViewRowExternalProps;

const listMonth: React.SFC<ListViewRowProps> = (props) => {
    // Grid Cell checks for date validity.
    const currentMonth = moment(props.allEvents[10].date);


    const today = moment().clone();
    const beginningOfWeek = moment().startOf("week");
    const relevantDays = props.allEvents.filter(day => moment(day.date).isSameOrAfter(today) && day.events.length > 0);
    return (
        <section id={currentMonth.format('YYYY-MM')} className="list-month list-month-js" >
            <div className="grid-month-days" data-month={currentMonth.format('YYYY-MM-DD')}>
                {
                    relevantDays.length > 0 ? relevantDays.map((day, idx) => <ListCell key={idx} day={day} currentMonth={moment(day.date)} />) : <ListEmptyCell currentMonth={moment(props.allEvents[10].date)} />
                }
            </div>
        </section>
    );
}

export default listMonth;


// WEBPACK FOOTER //
// ./app/calendar/views/list-month.tsx